import { render, staticRenderFns } from "./PersEinstellungen.vue?vue&type=template&id=90e9926a&scoped=true"
import script from "./PersEinstellungen.vue?vue&type=script&lang=ts"
export * from "./PersEinstellungen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e9926a",
  null
  
)

export default component.exports